import React from 'react'
import { Link } from 'react-router-dom'
import { useServer } from '../context/ServerContext'

const TopPlayers: React.FC = () => {
	const { topPlayers } = useServer()

	return (
		<section className='bg-sky-50 bg-opacity-90 p-6 md:col-span-1'>
			<h2 className='text-2xl font-bold text-sky-600 mb-4 text-center'>
				TOP PLAYERS
			</h2>
			<div className='overflow-x-auto'>
				<table className='w-full border-collapse border border-gray-300'>
					<thead className='bg-blue-100 text-blue-900'>
						<tr>
							<th className='border border-gray-300 py-2'>#</th>
							<th className='border border-gray-300 py-2'>Name</th>
							<th className='border border-gray-300 py-2'>
								Lvl{' '}
								<sup className='text-yellow-500 align-super text-xs'>ML</sup>
							</th>
							<th className='border border-gray-300 py-2'>
								RR <sup className='text-yellow-500 align-super text-xs'>GR</sup>
							</th>
						</tr>
					</thead>
					<tbody>
						{topPlayers.map((player, index) => (
							<tr key={index} className='border-t border-gray-700'>
								<td className='p-3'>{index + 1}</td>
								<td className='p-3'>
									<Link
										to={`/character/${player.Name}`}
										className='text-sky-600 hover:text-red-500 text-xs'
									>
										{player.Name}
									</Link>
								</td>
								<td className='p-3 text-sky-600'>
									{player.CLevel}{' '}
									<sup className='text-red-500 align-super text-xs'>
										{player.MasterLevel}
									</sup>
								</td>
								<td className='p-3 text-sky-600'>
									{player.ResetCount}{' '}
									<sup className='text-red-500 align-super text-xs'>
										{player.MResets}
									</sup>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</section>
	)
}

export default TopPlayers
